import React from "react";
import { PageHeader } from "@features/shared";
import { usePageInitialization } from "@features/shared/hooks/usePageInitialization";
import TotalFeedback from "./components/TotalFeedback";

// MyDiary feature - Market working diary components
export { default as TotalFeedback } from './components/TotalFeedback';
export { default as PreviousObservation } from './components/PreviousObservation';
export { default as NewFeedback } from './components/NewFeedback';

/**
 * MyDiaryPage - Page wrapper
 * Renders PageHeader + gray container + TotalFeedback
 */
export const MyDiaryPage = () => {
  usePageInitialization();
  return (
    <>
      <PageHeader title="Market Working" path="/" />
      <div className="container p-0 bg-[#F5F5F5]">
        <TotalFeedback />
      </div>
    </>
  );
};
